import { render, staticRenderFns } from "./ResetPasswordUpdatePage.vue?vue&type=template&id=7662064e&scoped=true"
import script from "./ResetPasswordUpdatePage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordUpdatePage.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordUpdatePage.vue?vue&type=style&index=0&id=7662064e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7662064e",
  null
  
)

export default component.exports